import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import { useFormikContext } from "formik";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import ConfigurationModal from "src/components/project/configuration/ConfigurationModal";
import CustomerTogglesModal from "./CustomerTogglesModal";
import useAuth from "src/hooks/useAuth";
import { useStorageEnabled } from "src/components/project/StorageEnabledProvider";
import useQueryParams from "src/hooks/useQueryParams";

const DEFAULT_CONFIGURATION_TAB = 0;

export default function CustomerSetup({ project, onToggleProjectInfoModal }) {
  const { user } = useAuth();
  const params = useQueryParams();
  const navigate = useNavigate();
  const { settings } = user.company;

  const configurationTab = params.get("configuration");
  const isConfigurationModalOpen = configurationTab !== null;
  const isTogglesModalOpen = params.get("toggles") === "true";

  const { values } = useFormikContext();
  const [storageEnabled, setStorageEnabled] = useStorageEnabled();

  const handleToggle = () => {
    if (!isConfigurationModalOpen) {
      onToggleProjectInfoModal();
      params.set("configuration", configurationTab || DEFAULT_CONFIGURATION_TAB);
    } else {
      params.delete("configuration");
    }
    navigate({ search: params.toString() });
  };

  const handleTogglesToggle = () => {
    if (!isTogglesModalOpen) {
      onToggleProjectInfoModal();
      params.set("toggles", "true");
    } else {
      params.delete("toggles");
    }
    navigate({ search: params.toString() });
  };

  useEffect(() => {
    setStorageEnabled(values.storageEnabled);
  }, [values.storageEnabled]);

  return (
    <>
      <Paper>
        <Box p={2}>
          <Typography fontWeight={500}>{settings.filter_field2} Setup</Typography>
          <Grid container spacing={1} sx={{ pt: 1.5 }}>
            <Grid size={{ xs: 6, sm: 3 }}>
              <Button fullWidth variant="outlined" color="primary" onClick={handleTogglesToggle}>
                {settings.filter_field2} Toggles
              </Button>
            </Grid>
            <Grid size={{ xs: 6, sm: 3 }}>
              <Button fullWidth variant="outlined" color="primary" onClick={handleToggle}>
                Field Configuration
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Paper>
      {isConfigurationModalOpen && (
        <ConfigurationModal
          project={project}
          selectedTab={configurationTab}
          storageEnabled={storageEnabled}
          originEnabled={!storageEnabled || project?.settings?.onsite_capture_to_warehouse_storage}
          destinationEnabled={!storageEnabled}
          reservationsTableFieldsEnabled={false}
          onClose={handleToggle}
        />
      )}
      {isTogglesModalOpen && (
        <CustomerTogglesModal open={isTogglesModalOpen} onClose={handleTogglesToggle} />
      )}
    </>
  );
}
